var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-0 pt-3 pb-3 bg-white border-bottom",attrs:{"id":"nav"}},[_c('h3',[_vm._v("Messages")]),_c('router-link',{attrs:{"to":{ path: '/messages/historical' }}},[_vm._v("Historical")]),(_vm.$route.params.id)?_c('span',[_vm._v(" | "),_c('router-link',{attrs:{"to":{ name: 'message_detail' }}},[_vm._v("Detail")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }